<template>
  <div
    class="i-landing-overlay"
    :class="{ on: visible }"
  >
    <div class="inner">
      <div class="spin"></div>
      <div class="msg">{{ message }}</div>
      <div class="sub">Personalizing your assessment</div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  visible: Boolean,
  message: { type: String, default: "Building your profile..." }
})
</script>

<style lang="scss" scoped>
.i-landing-overlay {
  position: fixed;
  inset: 0;
  z-index: 50;
  background: $white;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.28s ease;

  &.on {
    opacity: 1;
    pointer-events: all;
  }

  .inner {
    text-align: center;
    transform: translateY(12px);
    transition: transform 0.36s ease 0.04s;

    .i-landing-overlay.on & {
      transform: translateY(0);
    }
  }

  .spin {
    width: 28px;
    height: 28px;
    border: 2px solid #0a0e1a14;
    border-top-color: $amber-mid;
    border-radius: 50%;
    animation: rot 0.6s linear infinite;
    margin: 0 auto 14px;
  }

  .msg {
    font-family: $serif;
    font-size: 18px;
    font-weight: 400;
    font-style: italic;
    color: #0a0e1a99;
    margin-bottom: 5px;
  }

  .sub {
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: #0a0e1a40;
  }
}
</style>
